export function applyRomanFeaturesToOrderDetails(sewingOrderDetails, features) {
  if (!sewingOrderDetails || !sewingOrderDetails.length) return;
  const featuresVal = features ? features.toString() : "";
  const needsValance =
    featuresVal === "Upholstered Valance Standard" ||
    featuresVal === "Upholstered Valance Two Shades on 1 Headrail";
  const needsTwoParts =
    featuresVal === "Two Shades on 1 Headrail" ||
    featuresVal === "Upholstered Valance Two Shades on 1 Headrail";

  sewingOrderDetails.forEach((detail) => {
    if (needsValance) {
      detail["HasValance"] = true;
    } else if (detail["HasValance"] !== undefined) {
      delete detail["HasValance"];
    }
    if (needsTwoParts) {
      detail["PartNum"] = 2;
    } else if (detail["PartNum"] !== undefined) {
      delete detail["PartNum"];
    }
  });
}
